import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("sr_admin_token")}` },
});

export const money = (n) => `$${Number(n).toFixed(0)}`;
